import React from "react";

import "./styles.scss"
import ChatHistoryMain from "../../esg-chat/chat-history";

const FundHistory = () => {
    return (
        <>
            <ChatHistoryMain model="Fund" searchBy="Public" />
        </>
    )
}

export default FundHistory